import React from 'react';
import { DIFFERENTIALS, TECHNOLOGIES } from '../../constants';
import { Icon, CheckItem, SectionTitle } from '../ui';

const Differentials = () => {
  return (
    <section id="diferenciais" className="py-12 sm:py-20 lg:py-28 bg-mesh">
      <div className="container mx-auto px-4">
        <SectionTitle 
          title="Por que a"
          highlight="GoShine?"
          description="Somos apaixonados pelo que fazemos e isso reflete em cada detalhe."
        />

        {/* Differentials Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
          {DIFFERENTIALS.map((diff, index) => (
            <div 
              key={index} 
              className="text-center group p-4 sm:p-6 lg:p-8 glass-effect rounded-xl sm:rounded-2xl hover:border-goshine-orange/30 transition-colors duration-300"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 lg:w-20 lg:h-20 mx-auto bg-gradient-to-br from-goshine-navy to-goshine-navy-light rounded-xl sm:rounded-2xl flex items-center justify-center mb-3 sm:mb-4 lg:mb-5 border border-white/5">
                <Icon icon={diff.icon} className="text-xl sm:text-2xl lg:text-3xl text-goshine-orange" />
              </div>
              <h3 className="text-sm sm:text-base lg:text-lg font-bold mb-2 group-hover:text-goshine-orange transition-colors">
                {diff.title}
              </h3>
              <p className="text-xs sm:text-sm lg:text-base text-gray-400 leading-relaxed">
                {diff.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Technologies Section */}
        <div className="mt-10 sm:mt-16 glass-effect p-5 sm:p-8 md:p-10 rounded-2xl sm:rounded-3xl">
          <div className="grid md:grid-cols-2 gap-6 sm:gap-10">
            {TECHNOLOGIES.map((tech, index) => (
              <div key={index}>
                <span className="text-goshine-purple-light font-semibold text-xs sm:text-sm uppercase tracking-wider">
                  {tech.label}
                </span>
                <h3 className="text-xl sm:text-2xl font-bold mt-2 mb-4">
                  {tech.title} <span className="gradient-text">{tech.highlight}</span>
                </h3>
                <p className="text-sm text-gray-300 mb-4 leading-relaxed">
                  {tech.desc}
                </p>
                <ul className="space-y-2">
                  {tech.items.map((item, itemIndex) => (
                    <CheckItem key={itemIndex}>{item}</CheckItem>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Differentials;
